/**
 * NormaAuth — Supabase auth + favorites wrapper.
 * Loads after vendor/supabase.min.js, exposes window.NormaAuth.
 */
(function () {
  'use strict';

  // ---- Config (public anon key — security is enforced by RLS) ----
  var SUPABASE_URL = (window.NormaConfig && window.NormaConfig.SUPABASE_URL) || 'https://bvofbtvxgwzhqjstitij.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ2b2ZidHZ4Z3d6aHFqc3RpdGlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2MzMyMzksImV4cCI6MjA4NjIwOTIzOX0.4YxMK6cvbY1EpX9HG5VrC06BezVuKjtl2tq5OzYAQ9A';
  var AUTH_REDIRECT_BASE_URL = 'https://normagrid.com';

  var supabase = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

  // ---- Auth helpers ----

  function buildAuthRedirectUrl(path) {
    return AUTH_REDIRECT_BASE_URL.replace(/\/$/, '') + path;
  }

  function signUp(email, password, firstName, lastName, username) {
    return supabase.auth.signUp({
      email: email,
      password: password,
      options: {
        data: { first_name: firstName || '', last_name: lastName || '', username: username || '' },
        emailRedirectTo: buildAuthRedirectUrl('/confirm-email?confirmed=1')
      }
    });
  }

  function isUsernameAvailable(username) {
    return supabase.rpc('is_username_available', { desired_username: username });
  }

  function signIn(email, password) {
    return supabase.auth.signInWithPassword({ email: email, password: password });
  }

  function signOut() {
    return supabase.auth.signOut();
  }

  function getSession() {
    return supabase.auth.getSession();
  }

  function getUser() {
    return supabase.auth.getUser();
  }

  function resetPasswordForEmail(email) {
    return supabase.auth.resetPasswordForEmail(email, {
      redirectTo: buildAuthRedirectUrl('/reset-password')
    });
  }

  function resendSignupConfirmation(email) {
    return supabase.auth.resend({
      type: 'signup',
      email: email,
      options: {
        emailRedirectTo: buildAuthRedirectUrl('/confirm-email?confirmed=1')
      }
    });
  }

  function updatePassword(newPassword) {
    return supabase.auth.updateUser({ password: newPassword });
  }

  function onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange(callback);
  }

  // ---- Profile ----

  function getProfile() {
    return supabase.auth.getUser().then(function (res) {
      if (!res.data.user) return { data: null, error: { message: 'Not authenticated' } };
      return supabase.from('profiles').select('*').eq('id', res.data.user.id).single();
    });
  }

  function updateProfile(updates) {
    var payload = {};
    for (var key in updates) {
      if (key !== 'id' && updates.hasOwnProperty(key)) payload[key] = updates[key];
    }
    return supabase.auth.getUser().then(function (res) {
      if (!res.data.user) return { data: null, error: { message: 'Not authenticated' } };
      return supabase.from('profiles').update(payload).eq('id', res.data.user.id);
    });
  }

  // ---- Favorites ----

  function getFavorites() {
    return supabase.auth.getUser().then(function (res) {
      if (!res.data.user) return { data: null, error: { message: 'Not authenticated' } };
      return supabase.from('favorites').select('regulation_id, created_at').eq('user_id', res.data.user.id).order('created_at', { ascending: false });
    });
  }

  function addFavorite(regulationId) {
    return supabase.from('favorites').insert({ regulation_id: regulationId });
  }

  function removeFavorite(regulationId) {
    return supabase.auth.getUser().then(function (res) {
      if (!res.data.user) return { data: null, error: { message: 'Not authenticated' } };
      return supabase.from('favorites').delete().eq('regulation_id', regulationId).eq('user_id', res.data.user.id);
    });
  }

  function checkIsAdmin() {
    return supabase.auth.getUser().then(function (res) {
      if (!res.data.user) return false;
      return supabase.from('profiles').select('is_admin').eq('id', res.data.user.id).single();
    }).then(function (res) {
      if (typeof res === 'boolean') return res;
      if (res.error) return false;
      return res.data && res.data.is_admin === true;
    });
  }

  // ---- Regulations (public read, admin write) ----

  function getRegulations() {
    return supabase.from('regulations').select('*').order('acronym');
  }

  function getRegulation(id) {
    return supabase.from('regulations').select('*').eq('id', id).single();
  }

  function createRegulation(data) {
    return supabase.from('regulations').insert(data).select().single();
  }

  function updateRegulation(id, data) {
    return supabase.from('regulations').update(data).eq('id', id).select().single();
  }

  function deleteRegulation(id) {
    return supabase.from('regulations').delete().eq('id', id);
  }

  // ---- Expose ----

  window.NormaAuth = {
    signUp: signUp,
    signIn: signIn,
    signOut: signOut,
    getSession: getSession,
    getUser: getUser,
    resetPasswordForEmail: resetPasswordForEmail,
    resendSignupConfirmation: resendSignupConfirmation,
    updatePassword: updatePassword,
    onAuthStateChange: onAuthStateChange,
    getProfile: getProfile,
    updateProfile: updateProfile,
    getFavorites: getFavorites,
    addFavorite: addFavorite,
    removeFavorite: removeFavorite,
    checkIsAdmin: checkIsAdmin,
    isUsernameAvailable: isUsernameAvailable,
    getRegulations: getRegulations,
    getRegulation: getRegulation,
    createRegulation: createRegulation,
    updateRegulation: updateRegulation,
    deleteRegulation: deleteRegulation
  };
})();
